<template>
  <button @click="$emit('click')"
    class="button w4 flex flex-row items-center justify-center"
    :class="[roleClass]"
    :disabled="disabled">
    <content-spinner v-if="loading" size="20" color="white"/>
    <span v-else class="db tc">{{ title }}</span>
  </button>
</template>

<script>
import ContentSpinner from '@/components/common/ContentSpinner.vue'

export default {
  props: {
    title: { default: 'Применить' },
    loading: { default: false },
    disabled: { default: false },
    role: { default: 'primary' } // primary, secondary
  },
  components: {
    ContentSpinner
  },
  data () {
    return {
      roleClass: this.role
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
